import React, { useState, useEffect } from "react";
import modules from "../../routes/modules.json";
import { useHistory } from "react-router-dom";
import { Form, FormControl, Modal } from "react-bootstrap";
import ButtonComp from "../../_helpers/Button";
import { useSelector } from "react-redux";

export default function SearchModule({ handleClose }) {
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [timer, setTimer] = useState(null);
  const { menuRights } = useSelector((state) => state.user);
  const handleInputChange = (e) => {
    const inputText = e.target.value;
    if (inputText === "") {
      setSuggestions([]);
      setSearchText("");
    } else {
      setSearchText(inputText);
      clearTimeout(timer);
      setTimer(
        setTimeout(() => {
          searchModules(inputText);
        }, 300)
      );
    }
  };

  const searchModules = (text) => {
    if (text) {
      const filteredModules = menuRights.filter((m) =>
        m.moduleName.toLowerCase().includes(text.toLowerCase())
      );
      setSuggestions(filteredModules);
    }
  };

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timer]);

  return (
    <>
      <Modal show={true}>
        <Modal.Header>
          <Modal.Title>{"Find Module"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <FormControl
                type="text"
                placeholder="Please Enter Module Name...!"
                value={searchText}
                onChange={handleInputChange}
                autoFocus
              // className="form-control searchicon"
              />
            </Form.Group>
          </Form>
          {suggestions.length > 0 && (
            <div style={{ height: 500, overflow: "auto" }}>
              {suggestions.map((module) => (
                <button
                  class="btn custom_checkbox"
                  href="Saveript:void(0)"
                  key={module.moduleName}
                  onClick={() => history.push(module.link)}
                >
                  <label class="form-check-label">{module.moduleName}</label>
                </button>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <ButtonComp
            variant="secondary"
            submitFunc={handleClose}
            type="Cancel"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
